/** Same osiCode as FM_MobileApp authService for Authorization/Authentication mobile-aligned endpoints. */
export const AUTH_OSI_CODE = '0a630248-b737-43e9-bd56-19ad41031be3'
